export type ClientStatus = 'active' | 'churned' | 'paused';

export const STATUS_LABEL: Record<ClientStatus, string> = {
  active: 'Aktiv',
  churned: 'Churned',
  paused: 'Pauset',
};

export interface AdminClientRow {
  id: string;
  name: string;
  vat_number: string | null;
  invoice_email: string | null;
  address: string | null;
  payment_terms_days: number;
  hourly_rate: string | null;
  default_sales_rep_id: string | null;
  default_sales_rep_name: string | null;
  status: ClientStatus;
  notes: string | null;
  project_count: number;
  updated_at: string;
}

export interface AdminClientFull {
  id: string;
  name: string;
  vatNumber: string | null;
  invoiceEmail: string | null;
  address: string | null;
  paymentTermsDays: number;
  hourlyRate: string | null;
  defaultSalesRepId: string | null;
  status: ClientStatus;
  /** V1.2 scope J. */
  trustpilotReviewReceived: boolean;
  /** V1.4 scope W. */
  cancellationNoticeMonths: number;
  notes: string | null;
  acquisitionSource: string | null;
  customerSince: string | null;
  clickupCrmTaskId: string | null;
  updatedAt: string;
}

export interface UserRow {
  id: string;
  display_name: string;
  email: string;
  role: string | null;
  active: boolean;
}
